module.exports = __webpack_public_path__ + "static/img/avatar-3.41a180f3.jpg";